import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Tooltip } from '@mui/material';

export default function DoneEditing({ ...props }) {
  const history = useHistory();

  return (
    <Tooltip title="Finish editing">
      <Button onClick={() => history.goBack()} variant="contained" color="secondary" {...props}>
        Done
      </Button>
    </Tooltip>
  );
}
